import { secToCeilMin } from '@/util/date-time-helper'

export default {
  computed: {
    getCookingAndDeliveryTime () {
      if (this.basket.cookingAndDeliveryTime) {
        const time = parseInt(this.basket.cookingAndDeliveryTime)
        if (!isNaN(time)) {
          return secToCeilMin(time) + ' МИН.'
        }
        return ''
      }
      return ''
    },
  },
}
